import { COMPONENTS } from '../../../components/components.registry';
import { DiscoveryWallConfig } from '../../../models';
import { ACTIONS_KEYS, GETTERS_KEYS } from '../../../store';

export const DEFAULT_DISCOVERY_WALL_CONFIG: DiscoveryWallConfig = {
  components: {
    panel: COMPONENTS.PANELS.SimplePanel,
    header: COMPONENTS.PURE.HTMLMessage,
    grid: COMPONENTS.PANELS.SlidingPanel,
    result: COMPONENTS.SMART.ConfigurableResult,
    footer: null
  },
  blocks: {
    section: {
      order: 1,
      resultsGetter: GETTERS_KEYS.emptySearch.sectionRecommendations,
      showTaggingGetter: GETTERS_KEYS.emptySearch.sectionShowTracking,
      requestAction: ACTIONS_KEYS.emptySearch.getSectionRecommendations,
      rows: 12
    },
    clicks: {
      order: 2,
      resultsGetter: GETTERS_KEYS.emptySearch.clicksRecommendations,
      showTaggingGetter: GETTERS_KEYS.emptySearch.clicksShowTracking,
      requestAction: ACTIONS_KEYS.emptySearch.getClicksRecommendations,
      rows: 12,
      maxProductsIds: 5
    },
    queries: {
      order: 3,
      resultsGetter: GETTERS_KEYS.emptySearch.queriesRecommendations,
      showTaggingGetter: GETTERS_KEYS.emptySearch.queriesShowTracking,
      requestAction: ACTIONS_KEYS.emptySearch.getQueriesRecommendations,
      rows: 12,
      maxQueries: 5
    },
    user: {
      order: 4,
      resultsGetter: GETTERS_KEYS.emptySearch.userRecommendations,
      showTaggingGetter: GETTERS_KEYS.emptySearch.userShowTracking,
      requestAction: ACTIONS_KEYS.emptySearch.getUserRecommendations,
      rows: 12
    }
  }
};
